import { AppUpdatesListPage } from '@app/app-updates';
import { AppUpdatesDetailsPage } from '../../app-details';

export const appUpdatesListRoute = {
  name: 'app-updates',
  path: '/release-notes',
  exact: true,
  component: AppUpdatesListPage,
  resources: [],
};

export const appUpdatesBundledChangesRoute = {
  name: 'app-updates-bundled-changes',
  path: '/release-notes/bundled-changes',
  exact: true,
  component: AppUpdatesListPage,
  resources: [],
};

export const appUpdatesDetailsRoute = {
  name: 'app-updates-details',
  path: '/release-notes/:id',
  exact: true,
  component: AppUpdatesDetailsPage,
  resources: [],
};
